
import { useState, useEffect } from 'react'
import React from 'react'
import './index.less'
import { Button } from 'antd'
console.log(React)

export default function Popup(props) {
  const [ifon, setIfon] = useState({
    activeId: null,
    loading: true,
    page: 1,
    type: null,
    data: {
      datas: null,
      total: null
    },
    active: null
  })

  useEffect(() => {
    if (props.rule) {
      props.rule(ifon.page, (obj) => {
        setIfon({
          ...ifon,
          loading: false,
          data: {
            datas: obj.datas,
            total: obj.total
          }
        })
      })
    }
  }, [])

  return (<div className='Popup'>
    <div className='Popup_titleArea'>
      <h3 className='title'>数据</h3>
      <i className='icon' onClick={() => {
        props.close && props.close()
      }}>x</i>
    </div>
    <div className='Popup_main'>
      <div className='main'>
        { ifon.loading && !ifon.data.datas && <div className='loading'>
          <img src='http://www.sucaijishi.com/uploadfile/2013/0527/20130527034923893.gif' />
          <span>加载中···</span>
        </div> }
        { !ifon.loading && (ifon.data.datas.length === 0) && <div className='noData'>
          <img src='https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fhbimg.b0.upaiyun.com%2Fb209937dc2276a7cb5a47fb831879af25c52fa1b25567-NGX9jR_fw658&refer=http%3A%2F%2Fhbimg.b0.upaiyun.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1650878654&t=f9f1987d94161d670b123b12a9cd8c29' />
        </div>}
        { !ifon.loading && ifon.data.datas.length && <div className='box'>
          <ul className='box_ul'>
            {props.children && ifon.data.datas.map((item, index) => {
              return <div key={index} onClick={() => {
                if (!ifon.active || (ifon.active.id !== item.id)) {
                  setIfon({
                    ...ifon,
                    active: item
                  })
                  return
                }
                setIfon({
                  ...ifon,
                  active: null
                })
              }}><props.children item={item} active={ifon.active}></props.children></div>
            }) }
          </ul>
        </div>}
      </div>
      <div className='paging'>
        <div className='pagingBox'>
          <span className={`${ifon.page === 1 ? 'disable' : ''}`} onClick={() => {
            if (ifon.page === 1) {
              return
            }
            haPaging(1, ifon, setIfon, props)
          }}>{`<<`}</span>
          <span className={`${ifon.page === 1 ? 'disable' : ''}`} onClick={() => {
            if (ifon.page === 1) {
              return
            }
            haPaging(ifon.page - 1, ifon, setIfon, props)
          }}>{`<`}</span>
          <span className='num'>{ifon.page}/{Math.ceil(ifon.data.total / 10)}</span>
          <span className={`${ifon.page === Math.ceil(ifon.data.total / 10) ? 'disable' : ''}`} onClick={() => {
            if (ifon.page === Math.ceil(ifon.data.total / 10)) {
              return
            }
            haPaging(ifon.page + 1, ifon, setIfon, props)
          }}>{`>`}</span>
          <span className={`${ifon.page === Math.ceil(ifon.data.total / 10) ? 'disable' : ''}`} onClick={() => {
            if (ifon.page === Math.ceil(ifon.data.total / 10)) {
              return
            }
            haPaging(Math.ceil(ifon.data.total / 10), ifon, setIfon, props)
          }}>{`>>`}</span>
        </div>
      </div>
    </div>
    <div className='Popup_buttonArea'>
      <Button>取消</Button>
      <Button type='primary' style={{ marginLeft: '10px' }} onClick={() => {
        props.change && props.change(ifon.active)
      }}>确定</Button>
    </div>
  </div>)
}

function haPaging(page, ifon, setIfon, props) {
  setIfon({
    ...ifon,
    loading: true,
    data: {
      datas: null,
      total: null
    }
  })

  const func = (obj) => {
    setIfon({
      ...ifon,
      page,
      data: {
        datas: obj.datas,
        total: obj.total
      },
      loading: false
    })
  }

  props.paging(page, func)
}

